@use '~/theme/theme' as *;
@use '~/theme/typography';

.content {
  gap: spacing(3);
}

.section {
  display: flex;
  flex-direction: column;
  gap: spacing(1);
  overflow: visible;
}

.row {
  display: flex;
  gap: spacing(2);
  overflow: visible;
}

.directionRow {
  display: flex;
  gap: spacing(2);
  align-items: flex-end;
}

.control {
  flex: 1 0 0;
}

.toggle {
  margin-top: spacing(1);
  margin-bottom: spacing(0.5);
}

.directionLabel {
  @include border-radius(sm);
  @include typography.body2;
  @include typography.regular;

  height: 38px;
  display: flex;
  background: color(grey-100);
  gap: spacing(2);
  min-width: spacing(15);
  justify-content: center;
  align-items: center;
  color: color(grey-700);

  .icon {
    @include icon-size(sm);
  }
}

.alertIcon {
  color: color(lobster-800);
  margin-left: spacing(1);
}

.tabs {
  flex: 1;
  overflow-y: auto;
}

.tabContainer {
  display: flex;
  padding-bottom: spacing(2);
}

.tab {
  @include typography.body2;
  @include typography.regular;

  color: color(grey-600);
  padding: spacing(0) spacing(2);
  line-height: 22px;
  height: 48px;
  align-items: center;
  display: flex;
  cursor: pointer;
  border-bottom: 2px solid transparent;

  &[data-hovered] {
    border-bottom: border(grey-400, md);
  }

  &[data-selected] {
    @include typography.semibold;

    color: color(grey-800);
    border-bottom: border(grey-800, md);
  }

  &[data-focused] {
    outline: none;
  }

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
    border-radius: 2px;
  }
}

.tabPanel {
  display: flex;
  flex-direction: column;
  gap: spacing(3);
}

.stepperContainer {
  display: flex;
  flex-direction: row;
  padding: spacing(2) spacing(3);
  justify-content: space-between;
  align-items: center;
  gap: spacing(1);
}

.stepperDivider {
  width: 110px;
  height: 0;
  border: border(grey-400);
}

.stepperItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.stepperCount {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  color: white;
  margin-right: spacing(1);
  background: color(violet-600);
}

.stepperNext {
  background: color(violet-400);
}

.stepperLabel {
  white-space: nowrap;
}
